export const warpcastSvg = (
  <svg
    data-testid="ock-warpcastSvg"
    role="img"
    aria-label="ock-warpcastSvg"
    width="100%"
    height="100%"
    viewBox="0 0 13 12"
    xmlns="http://www.w3.org/2000/svg"
    className="fill-ock-foreground w-full h-full"
  >
    <path
      d="M2.23071 0H10.6153V12H9.38451V6.50322H9.37245C9.23641 4.98404 7.96783 3.79353 6.42299 3.79353C4.87815 3.79353 3.60957 4.98404 3.47354 6.50322H3.46147V12H2.23071V0Z"
      className="fill-ock-foreground"
    />
    <path
      d="M0 1.70312L0.499999 3.40635H0.923066V10.2967C0.71065 10.2967 0.538456 10.47 0.538456 10.6838V11.1483H0.461541C0.249125 11.1483 0.0769147 11.3216 0.0769147 11.5354V11.9999H4.38458V11.5354C4.38458 11.3216 4.21239 11.1483 3.99998 11.1483H3.92306V10.6838C3.92306 10.47 3.75085 10.2967 3.53843 10.2967H3.07691V1.70312H0Z"
      className="fill-ock-foreground"
    />
    <path
      d="M9.46163 10.2967C9.24921 10.2967 9.077 10.47 9.077 10.6838V11.1483H9.00009C8.78767 11.1483 8.61548 11.3216 8.61548 11.5354V11.9999H12.9231V11.5354C12.9231 11.3216 12.7509 11.1483 12.5385 11.1483H12.4616V10.6838C12.4616 10.47 12.2894 10.2967 12.077 10.2967V3.40635H12.5001L13.0001 1.70312H9.92315V10.2967H9.46163Z"
      className="fill-ock-foreground"
    />
  </svg>
);
